export const THEME_COOKIE = 'theme';

/** Every theme except the default has a `[data-theme='…']` block in `src/client/styles/globals.css`. */
export const THEMES = [
  'gold-light',
  'gold-dark',
  'light',
  'dark',
  'solarized-light',
  'solarized-dark',
  'catppuccin-latte',
  'catppuccin-mocha',
] as const;

/** Themes with a dark background. They get `data-scheme="dark"`, which the `dark:` variant reads. */
export const DARK_THEMES: readonly (typeof THEMES)[number][] = [
  'gold-dark',
  'dark',
  'solarized-dark',
  'catppuccin-mocha',
];

export const DEFAULT_THEME = 'light';

export type ArtSet = 'classic' | 'gold';

/** The gold favicons and `connecting-line.svg` live under this path, at the same relative path. */
export const GOLD_ASSETS = '/assets/gold';

/** Images, favicons and inline-SVG art per theme. */
export const THEME_ART: Record<(typeof THEMES)[number], ArtSet> = {
  'gold-light': 'gold',
  'gold-dark': 'gold',
  light: 'classic',
  dark: 'classic',
  'solarized-light': 'classic',
  'solarized-dark': 'classic',
  'catppuccin-latte': 'classic',
  'catppuccin-mocha': 'classic',
};
